import type { GetPermissionRolesResponse } from '@oy/types';
import axios, { AUTH_PREFIX } from 'src/clients/axios';

export function getB2xPermissionRoles(roleName?: string) {
  return axios.request<GetPermissionRolesResponse>({
    method: 'get',
    url: `${AUTH_PREFIX}/permission/product-role`,
    params: {
      domain: 'BUSINESS_DASHBOARD',
      roleName,
    },
  });
}
